<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      {{ modalData.title }}
    </div>
    <div class="inputs">
      <div class="info">
        <span class="info-key">{{$t('competitions.modal.status')}}:</span>
        <span class="info-value">
          <dropdown
            :defaultText="'Status'"
            :selected="selected"
            :list="statuses"
            @changeOption="selected = $event"
          />
        </span>
      </div>
      <div v-if="modalData.type === 'create'" class="info">
        <span class="info-key">{{$t('competitions.modal.group')}}:</span>
        <span class="info-value">
          <dropdown
            :defaultText="'Grupa'"
            :selected="selectedAge"
            :list="ages"
            @changeOption="selectedAge = $event"
          />
        </span>
      </div>
      <div v-if="modalData.type === 'create'" class="info">
        <span class="info-key">{{$t('competitions.modal.type')}}:</span>
        <span class="info-value">
          <dropdown
            :defaultText="'Tip'"
            :selected="selectedType"
            :list="types"
            @changeOption="selectedType = $event"
          />
        </span>
      </div>
      <div class="info">
        <span class="info-key">{{$t('competitions.modal.title')}}:</span>
        <span class="info-value">
          <input
            maxlength="255"
            type="text"
            v-model="modalData.comp.cmp_name"
          />
        </span>
      </div>
      <div class="info">
        <span class="info-key">{{$t('competitions.modal.description')}}:</span>
        <span class="info-value">
          <input
            maxlength="1100"
            type="text"
            v-model="modalData.comp.cmp_description"
          />
        </span>
      </div>
      <div class="info">
        <span class="info-key">{{$t('competitions.modal.subject')}}:</span>
        <span class="info-value">
          <input
            maxlength="255"
            type="text"
            v-model="modalData.comp.cmp_theme"
          />
        </span>
      </div>
      <div class="info">
        <span class="info-key">{{$t('competitions.modal.worksFrom')}}:</span>
        <span class="info-value">
          <datetime v-model="modalData.comp.cmp_from_post" type="datetime" />
        </span>
      </div>
      <div class="info">
        <span class="info-key">{{$t('competitions.modal.worksTo')}}:</span>
        <span class="info-value">
          <datetime v-model="modalData.comp.cmp_to_post" type="datetime" />
        </span>
      </div>
      <div class="info">
        <span class="info-key">{{$t('competitions.modal.voteFrom')}}:</span>
        <span class="info-value">
          <datetime v-model="modalData.comp.cmp_from_vote" type="datetime" />
        </span>
      </div>
      <div class="info">
        <span class="info-key">{{$t('competitions.modal.voteTo')}}:</span>
        <span class="info-value">
          <datetime v-model="modalData.comp.cmp_to_vote" type="datetime" />
        </span>
      </div>
    </div>
    <div class="btn-wrapper">
      <div @click="ok()" class="btn">
        ok
      </div>
      <div @click="closeModal()" class="btn">
        cancel
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/dropdown.vue'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'ChangeCompetitionStatusModal',
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  components: {
    Dropdown
  },
  data () {
    return {
      statuses: [
        {
          label: this.$t('competitions.status.active'),
          value: 'active'
        },
        {
          label: this.$t('competitions.status.next'),
          value: 'upcoming'
        },
        {
          label: this.$t('competitions.status.archived'),
          value: 'archive'
        },
        {
          label: this.$t('competitions.status.nextYear'),
          value: 'next_year'
        }
      ],
      selected: null,
      ages: [
        {
          label: this.$t('competitions.ages.1'),
          value: 1
        },
        {
          label: this.$t('competitions.ages.2'),
          value: 2
        },
        {
          label: this.$t('competitions.ages.3'),
          value: 3
        },
        {
          label: this.$t('competitions.ages.4'),
          value: 4
        }
      ],
      selectedAge: null,
      types: [
        {
          label: 'PDF',
          value: 1
        },
        {
          label: 'LINK',
          value: 2
        },
        {
          label: 'IMAGE',
          value: 3
        }
      ],
      selectedType: null
    }
  },
  mounted () {
    this.setActiveStatus()
  },
  methods: {
    setActiveStatus () {
      if (this.modalData.comp) {
        if (this.modalData.comp.cmp_active) {
          // this.selected = {
          //   label: 'Aktivan',
          //   value: 'active'
          // }
          this.selected = this.statuses[0]
        } else if (this.modalData.comp.cmp_upcoming) {
          // this.selected = {
          //   label: 'Sledi',
          //   value: 'upcoming'
          // }
          this.selected = this.statuses[1]
        } else if (this.modalData.comp.cmp_archived) {
          // this.selected = {
          //   label: 'Arhiviran',
          //   value: 'archive'
          // }
          this.selected = this.statuses[2]
        } else if (this.modalData.comp.cmp_next_year) {
          // this.selected = {
          //   label: 'Sledeće godine',
          //   value: 'next_year'
          // }
          this.selected = this.statuses[3]
        } else {
          this.selected = null
        }
      }
    },
    hasAllInputs () {
      let res = false
      console.log(this.selected.value, 'asd')
      if (this.selected.value === 'next_year') {
        if (this.modalData.type === 'create') {
          if (
            this.selected &&
            this.selectedAge &&
            this.selectedType &&
            this.modalData.comp.cmp_name &&
            this.modalData.comp.cmp_description &&
            this.modalData.comp.cmp_theme
          ) {
            res = true
          }
        } else {
          if (
            this.selected &&
            this.modalData.comp.cmp_name &&
            this.modalData.comp.cmp_description &&
            this.modalData.comp.cmp_theme
          ) {
            res = true
          }
        }
      } else {
        if (this.modalData.type === 'create') {
          if (
            this.selected &&
            this.selectedAge &&
            this.selectedType &&
            this.modalData.comp.cmp_name &&
            this.modalData.comp.cmp_description &&
            this.modalData.comp.cmp_theme &&
            this.modalData.comp.cmp_from_post &&
            this.modalData.comp.cmp_to_post &&
            this.modalData.comp.cmp_from_vote &&
            this.modalData.comp.cmp_to_vote
          ) {
            res = true
          }
        } else {
          if (
            this.selected &&
            this.modalData.comp.cmp_name &&
            this.modalData.comp.cmp_description &&
            this.modalData.comp.cmp_theme &&
            this.modalData.comp.cmp_from_post &&
            this.modalData.comp.cmp_to_post &&
            this.modalData.comp.cmp_from_vote &&
            this.modalData.comp.cmp_to_vote
          ) {
            res = true
          }
        }
      }
      return res
    },
    ok () {
      if (!this.hasAllInputs()) {
        this.$toast.error(this.$t('competitions.modal.errAll'), {
          duration: 8000
        })
        return
      }
      if (this.modalData.type === 'create') {
        this.modalData.ok(
          this.selected.value,
          this.selectedAge.value,
          this.selectedType.value
        )
      } else {
        this.modalData.ok(this.selected.value)
      }
      eventBus.$emit('closeModal')
    },
    closeModal () {
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/btnStyles.scss';
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import '@/assets/scss/scrollbarStyles.scss';
  @include scrollbar;
  @import '@/assets/scss/cardStyles.scss';

  .info {
    margin-bottom: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
    flex-wrap: wrap;

    .info-key {
      font-weight: normal;
      font-size: 13px;
      line-height: 21px;
      color: #787878;
      margin-right: 15px;
      // white-space: nowrap;
      min-width: 100px;
    }
    .info-value {
      font-weight: 800;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: $text-color;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      flex-grow: 1;
      justify-content: flex-start;

      input[type='text'] {
        width: 100%;
      }
      .filter-wrapper {
        margin-right: 10px;
      }
      .declaration-wrapper {
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          margin-left: 5px;
        }
      }
      input {
        height: 40px;
        border: 1px solid #e8e8e8;
        padding-left: 5px;
      }
    }
  }

  .dropdown-wrapper {
    width: 200px;
  }

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 10px 0px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
